import { useNavigate } from "react-router-dom";
interface PaywallModalProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  description?: string;
}

export default function PaywallModal({ open, onClose, title, description }: PaywallModalProps) {
  const navigate = useNavigate();

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center px-4" onClick={onClose}>
      <div className="bg-white w-full max-w-xs rounded-2xl p-6 shadow-xl text-center" onClick={(e) => e.stopPropagation()}>
        <div className="w-14 h-14 rounded-full bg-gradient-to-br from-primary-500 to-accent-500 flex items-center justify-center mx-auto mb-4">
          <i className="ri-customer-service-2-fill text-white text-2xl" />
        </div>
        <h3 className="text-base font-bold text-foreground-950 mb-1">联系客服</h3>
        <p className="text-xs text-foreground-400 mb-5 leading-relaxed">
          {description || "如需开通权限，请联系在线客服"}
        </p>
        <button
          onClick={() => { onClose(); navigate("/profile/about/contact"); }}
          className="w-full py-2.5 rounded-xl text-sm font-semibold bg-gradient-to-r from-primary-500 to-accent-500 text-white cursor-pointer hover:opacity-90 transition-all mb-2 shadow-sm"
        >
          <i className="ri-customer-service-2-line mr-1" />联系客服
        </button>
        <button onClick={onClose} className="w-full py-2 text-xs text-foreground-400 cursor-pointer hover:text-foreground-600 transition-colors">
          取消
        </button>
      </div>
    </div>
  );
}
